<script>
import draggable from 'vuedraggable'
import tourMixin from '@src/mixins/tour'

import ExtraFieldListItem from './ExtraFieldListItem'
import HistoryExtraField from './HistoryExtraField'
import { generateUniqueString } from '@utils'

export default {
  components: {
    ExtraFieldListItem,
    HistoryExtraField,
    draggable,
  },
  mixins: [tourMixin],
  tourName: 'productInventory',
  props: {
    defaultValue: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      activeTab: 'byOrder',
      activeGroupIndex: '',
      disabledTab: false,
      list: {
        byOrder: [],
        bySize: [],
      },
      currentGroup: 'byOrder',
      dialogVisible: false,
      drag: false,
      activeNames: [],
    }
  },
  mounted(){
  },
  computed: {
    disabledAddNewButton() {
      return !this.tourIsActive && !(this.activeGroupIndex === '')
    },
    stepValid() {
      return !this.disabledAddNewButton
    },
  },
  watch: {
    stepValid: {
      handler: 'emitStepValidate',
      immediate: true,
    },
    defaultValue: {
      immediate: true,
      deep: true,
      handler: 'updateListValue',
    },
  },
  methods: {
    updateListValue() {
      Object.keys(this.defaultValue.orderExtrafields).forEach((displayType) => {
        const typeArray = this.defaultValue.orderExtrafields[displayType]
        if (typeArray !== null) this.list[displayType] = typeArray
      })
    },
    emitStepValidate(valid) {
      this.$emit('validate', valid)
    },
    updateActiveGroupIndex(index) {
      this.activeGroupIndex = index
    },
    cancelEditGroup(index) {
      // if the group has only one property (_key)
      if (Object.keys(this.list[this.currentGroup][index]).length) {
        this.removeGroup(index, this.currentGroup)
      }
      this.updateActiveGroupIndex('')
    },
    saveGroup({ index, data }) {
      this.$set(this.list[this.currentGroup], index, data)
      this.updateActiveGroupIndex('')
    },
    removeGroup(index) {
      const delIndex = this.activeNames.indexOf(`${index}`);
      if(delIndex > -1 ){
        this.activeNames.splice(delIndex, 1)
        if(!this.list[this.currentGroup][index].title) {
          this.updateActiveGroupIndex('')
        }
      }
      this.list[this.currentGroup].splice(index, 1)
    },
    addNewGroup() {
      this.closeCard()
      this.list[this.currentGroup].push({
        _key: generateUniqueString(15),
      })
      this.updateActiveGroupIndex(this.list[this.currentGroup].length - 1)
      this.activeNames.push(`${this.list[this.currentGroup].length - 1}`)
    },
    /**
     * @description 按下新增問題時，關閉所有先前的card
     */
    closeCard(){
      let length = this.list[this.currentGroup].length
      for(let i = 0 ; i < length ; i++){
        this.$refs[`card${i}`][0].closeCard()
      }
    },
    handleClick(tab, event) {
      this.currentGroup = tab.name
    },
    closeDialog() {
      this.dialogVisible = false
    },
    addGroupFromHistory(list) {
      // clone history question to current question, avoid modified
      const newExtraFields = list.map((item) => {
        return {
          ...item,
          id: '',
          displayType: this.currentGroup,
        }
      })
      this.list[this.currentGroup] = [
        ...this.list[this.currentGroup],
        ...newExtraFields,
      ]
    },
    /**
    * @description 問題形式
    */
    typeSelect(type) {
      const typeList = {
        'checkbox': '複選',
        'text': '簡答',
        'radio': '單選'
      }
      return typeList[type]
    },
  },
}
</script>

<template>
  <div>
    <div :class="$style.stage">
      <el-row v-show="list[currentGroup].length === 0">
        <el-col :span="24" :class="$style.placeholder">
          <BaseIcon name="clipboard-list" />
        </el-col>
        <el-col :span="24" :class="$style.placeholder">
          <span>按下新增題目開始自訂問題</span>
        </el-col>
      </el-row>
      <el-row v-show="!disabledAddNewButton" :gutter="20" :class="$style.questionSet">
        <el-col :span="12">
          <h4>題目設定</h4>
        </el-col>
        <el-col :span="12">
          <el-button v-show="!disabledAddNewButton" :disabled="disabledAddNewButton" class="is-round"
            type="primary" plain @click="addNewGroup">
            <BaseIcon name="plus" />
            <span>新增題目</span>
          </el-button>
        </el-col>

      </el-row>
      <div v-show="list[currentGroup].length">
        <draggable v-model="list[currentGroup]" animation="200" handle=".handle-subject" @start="drag = true"
          @end="drag = false">
          <transition-group type="transition" :name="!drag ? 'flip-list' : null">
            <el-collapse v-for="(group, index) in list[currentGroup]" :key="index" v-model="activeNames" class="custom-collapse isStyleLimit is-border is-round" style="margin-bottom: 10px">
              <el-collapse-item style="border:0" :name="`${index}`">
                <div slot="title" class="el-collapse-title d-flex align-items-center"
                  ><span class="">{{ group.title || '問題標題' }}</span>
                  <div class="ml-auto handle-subject" style="text-align: right; padding-right: 15px">
                    <span class="mr-5 text-text-light">{{ typeSelect(group.type) }}</span>
                    <el-switch class="mr-4" :class="$style['header__rightUser__switch']" v-model="group.required" active-text="必填"
                      inactive-text="非必填" :active-value="1" :inactive-value="0" style="width:160px;"></el-switch>
                    <BaseIcon icon-style="fas" name="fa-grip-dots-vertical" class="text-primary"/>
                  </div>
                </div>
                <ExtraFieldListItem  :class="$style.fieldListStyle"
                  :key="`ExtraFieldListItem-${index}`" :item-index="index" :default-value="group" :group="currentGroup"
                  :is-active="activeGroupIndex === index" :is-disabled="
                    activeGroupIndex !== '' && activeGroupIndex !== index
                  " @save="saveGroup" @remove="removeGroup" @edit="updateActiveGroupIndex" @cancel="cancelEditGroup" 
                  :ref="`card${index}`"/>
              </el-collapse-item>
            </el-collapse>
          </transition-group>
        </draggable>
      </div>
      <!-- <el-row v-show="!disabledAddNewButton" :gutter="20" :class="$style['margin-top']">
        <el-col :span="12">
          <el-button v-show="!disabledAddNewButton" :disabled="disabledAddNewButton" class="is-fullwidth is-round"
            type="primary" plain @click="addNewGroup">
            <BaseIcon name="plus" />
            <span>新增題目</span>
          </el-button>
        </el-col>
        <el-col :span="12">
          <el-button class="is-fullwidth is-round" @click="dialogVisible = true">
            <span>選擇已新增的題目</span>
          </el-button>
        </el-col>
      </el-row> -->
    </div>

    <el-dialog title="選擇已新增的題目" width="400px" :visible.sync="dialogVisible" append-to-body modal-append-to-body
      :destroy-on-close="true" top="0">
      <HistoryExtraField @close="closeDialog" @add="addGroupFromHistory" />
    </el-dialog>
  </div>
</template>

<style lang="scss" module>

.el-tabs__nav {
  opacity: 0.5;

  &::before {
    content: '';
    height: 50px;
    width: 244px;
    position: absolute;
    z-index: 3;
    cursor: not-allowed;
  }
}

.placeholder {
  text-align: center;
  color: #bebebe;
  opacity: 0.5;
  margin-top: 15px;

  & svg {
    font-size: 100px;
  }

  & span {
    font-size: 18px;
  }

  &:last-child {
    margin-bottom: 30px;
  }
}

.stage {
  padding: 18px 20px;
  background-color: white;
}

.margin-top {
  margin-top: 20px;
}

.questionSet {
  margin-bottom: 11px;
  :global {
    .el-button {
      background-color: $color-primary;
      color: white;
      position: absolute;
      right: 10px;
    }
  }
}

.fieldListStyle {
  // margin-bottom: 10px;
  // border: 1px solid $color-border-for-bg-white;
  // border-radius: $border-radius;
}
</style>
